__turbopack_context__.v({
  "label": "TopOrganizerLabel-module-scss-module__I6iP_G__label",
  "text": "TopOrganizerLabel-module-scss-module__I6iP_G__text",
});
